import { render } from "./CbBannerSlot.vue?vue&type=template&id=2dcfb27e&scoped=true&ts=true"
import script from "./CbBannerSlot.vue?vue&type=script&lang=ts"
export * from "./CbBannerSlot.vue?vue&type=script&lang=ts"

import "./CbBannerSlot.vue?vue&type=style&index=0&id=2dcfb27e&lang=css&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dcfb27e"]])

export default __exports__